<script setup lang="ts">
  import { IconArrowLeft, IconClear, Text } from "@ui-kit";
  import { TopBar, StatusBar } from "@src/components";

  const emit = defineEmits<{
    "click:back": [value: void];
    "click:clear": [value: void];
  }>();
</script>

<template>
  <div class="sales-item-list" data-testid="sales-item-list">
    <StatusBar />
    <TopBar
      :title="$t('Проверка продаж на КСО')"
      @click:left="() => emit('click:back')"
      @click:right="() => emit('click:clear')"
      data-testid="top-bar-sales"
    >
      <template #left>
        <IconArrowLeft />
      </template>
      <template #right>
        <IconClear />
      </template>
    </TopBar>
    <div class="content">
      <slot />
      <Text font="body-regular-14" color="secondary" class="placeholder">
        {{ $t("Отсканируйте товар, чтобы он появился в списке") }}
      </Text>
    </div>
  </div>
</template>

<style scoped>
  .sales-item-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    background-color: var(--sf-base-background-primary);

    .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 8px;
      padding: 6px 16px;
      overflow-y: auto;
    }

    .placeholder {
      text-align: center;
    }
  }
</style>
